import { getInfo, TruncateWithTooltipFormatter } from '@Components/Grid/components/Table/formatters';

export default function RedirectFormatter({ info }) {
  const { value } = getInfo(info)

  if (value?.length < 100) {
    return value
  }

  return <TruncateWithTooltipFormatter value={value} />
}
